// extracted by mini-css-extract-plugin
module.exports = {"loadAction":"_1jOuL","borderBottom":"_1FU-y"};